module.exports = __webpack_public_path__ + "img/it.d3ad8488.svg";